// @ts-nocheck

import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { createArticle } from "../../../features/article"; // Assuming you have this action to create an article
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import { CKEditor } from "ckeditor4-react"; 
import { uploadPhoto } from "../../../features/photo"; // Assuming you have a photo upload action
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const AddArticle = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "", // Predefined title
    sub_title: "", // Predefined subtitle
    description: "", // Predefined description
    status: "Draft", // Default status
    thumbnail_img: "", 
    location_name:"",
    is_home:false
  });

  const [imagePreview, setImagePreview] = useState(null); // For image preview

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value,checked } = e.target;
    console.log(name, value,'name, value');
    
    setFormData((prev) => ({
      ...prev,
      [name]: name ==='is_home'?checked: value,
    }));
  };

  const handleEditorChange = (e: any) => {
    setFormData((prev) => ({
      ...prev,
      content: e.editor.getData(),
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        thumbnail_img: e.target.files[0], // Handle thumbnail image change
      }));
    }
  };

  const handleSubmit = () => {
    // Dispatch createArticle with formData
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
console.log(key,'key');
console.log(value,'value');

      if (value !== undefined) {
        if(key==='is_home'){
          formDataFinal.append(key, value === 'on'?true:false); 
        }else{

          formDataFinal.append(key, value);
        }
      }

    });

    dispatch(createArticle(formDataFinal))
      .then((res) => {
        toast.success(res.payload.message); // Assuming you have a toast function
        navigate('/article'); // Redirect to article list or another page
      })
      .catch((err) => {
        console.log(err, "error");
        toast.error("An error occurred while creating the article.");
      });
  };

  console.log(formData,'formData');
  

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Add Article
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="title"
              placeholder="Enter the article title"
              value={formData.title}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Sub Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="sub_title"
              placeholder="Enter the article subtitle"
              value={formData.sub_title}
              onChange={handleChange}
            />
          </SoftBox>

         

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Description
              </SoftTypography>
            </SoftBox>
              <CKEditor
                      editor={ ClassicEditor }
                      data=""
                      onInit={ editor => {
                          // You can store the "editor" and use when it is needed.
                          console.log( 'Editor is ready to use!', editor );
                      } }
                      onChange={ ( event, editor ) => {
                          const data = editor.getData();
                          console.log( { event, editor, data } ,'onCHnagwe');

                          setFormData((prev) => ({
                            ...prev,
                            ['description']: data,
                          }));
                      } }
                      // onBlur={ ( event, editor ) => {
                      //     console.log( 'Blur.', editor );
                      // } }
                      // onFocus={ ( event, editor ) => {
                      //     console.log( 'Focus.', editor );
                      // } }
                  />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Location Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="location_name"
              placeholder="Enter the location name"
              value={formData.location_name}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2} display="flex" alignItems="center" >
            <SoftBox mb={1} ml={0.5} mr={1}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
              Is Home
              </SoftTypography>
            </SoftBox>
            <input
      
                type="checkbox"
                name="is_home"
                checked={formData.is_home}
                onChange={handleChange}
                sx={{ border: 'none' }}
    />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Status
              </SoftTypography>
            </SoftBox>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="Draft">Draft</option>
              <option value="Published">Published</option>
            </select>
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Thumbnail Image
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept="image/*"
              name="thumbnail_img"
              onChange={handleImageChange}
              style={{ width: "100%" }}
            />
            {imagePreview && (
              <img src={imagePreview} alt="Preview" style={{ width: "150px", height: "150px",marginTop: "20px" }} />
            )}
          </SoftBox>

          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddArticle;
